export default __webpack_public_path__ + "static/media/demonologist_color.f708c863.png";